module.exports = __webpack_public_path__ + "static/media/sitting.bcfefd30.webp";